var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "pt-0" },
    [
      _c("loading", { attrs: { loading: _vm.loading } }),
      _vm._v(" "),
      _c(
        "v-row",
        { attrs: { justify: "space-around mt-5 pt-0" } },
        [
          _c(
            "v-col",
            {
              staticClass: "mt-0 pt-0",
              attrs: {
                xl: _vm.defaultColXl,
                ld: _vm.defaultColLd,
                md: _vm.defaultColMd,
                sm: _vm.defaultColSm,
                xs: _vm.defaultColXs
              }
            },
            [
              _c(
                "v-sheet",
                { attrs: { color: "blue lighten-5" } },
                [
                  _c(
                    "v-row",
                    { attrs: { justify: "space-around mt-0 pt-0" } },
                    [
                      _c(
                        "v-col",
                        {
                          attrs: {
                            xl: "9",
                            ld: "10",
                            md: "11",
                            sm: "11",
                            xs: "11"
                          }
                        },
                        [
                          _c("div", [
                            _vm.alreadySubmitFlag
                              ? _c("div", [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$t(
                                          "view.contract_form.confirm_identification.identification_error_message.already_submit_message"
                                        )
                                      ) +
                                      "\n                            "
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.approvedFlag
                              ? _c("div", [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$t(
                                          "view.contract_form.confirm_identification.identification_error_message.approved_message"
                                        )
                                      ) +
                                      "\n                            "
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.defaultErrorFlag
                              ? _c("div", [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$t(
                                          "view.contract_form.confirm_identification.identification_error_message.default_message"
                                        )
                                      ) +
                                      "\n                            "
                                  )
                                ])
                              : _vm._e()
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("error-panel", {
                ref: "errorPanel",
                attrs: { error: _vm.hasError }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-17f89a1a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17f89a1a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/contract_form/EkycHoujinProxyTop.vue
// module id = 0DAt
// module chunks = 1